import axiosInstance from "../utils/axios"
// import { handleApiError } from "../utils/errorHandler"

export const testimonyLaboratoryService = {
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get('/testimoni-laboratory/paginate', {
      params,
    })
    return response.data
  },
  store: async (data) => {
    const response = await axiosInstance.post('/testimoni-laboratory', data)
    return response.data
  },
  update: async (id, data) => {
    const response = await axiosInstance.put(`/testimoni-laboratory/${id}`, data);
    return response.data;
  },  
  delete: async (id) => {
    const response = await axiosInstance.delete(`/testimoni-laboratory/${id}`)
    return response.data
  },
}